import { BulletStatus } from './bullet-status';
import { getWithdrawStatusLabel } from './withdraw-status.utils';

/**
 * Canonical presentation of a withdraw/settlement status. Withdraw status is
 * rendered identically by the gateway withdraw list, the withdraw details
 * page and the marketing withdraw tables, so the status→tone mapping lives
 * here instead of being re-derived per consumer.
 */
const WithdrawStatusBullet = ({
    status,
    label,
}: {
    status?: string;
    label?: string;
}) => (
    <BulletStatus
        type={
            status === 'created' || status === 'send_shaparak'
                ? 'warning'
                : status === 'accepted'
                  ? 'success'
                  : 'error'
        }
        label={label ?? getWithdrawStatusLabel(status || '')}
    />
);

export { WithdrawStatusBullet };
